import jwtutil from 'jsonwebtoken'
const privateKey = ''
const publicKey = `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDBvlE4HLs0HKa8bThwEdpXTiqy
4TmYXwTM97Tf7eQTgQl46BhyfZqtexEt67H1VH4WZLak4qn1IkPb2ATeYXaE/CwI
J+sZiuQ+uTk3GXSXJ6OSB7A1nnTCTWd2h0WD35oJNlw1+vSEOqaCqqPc54revI2D
fX1oDcXaKAuMaf8NfQIDAQAB
-----END PUBLIC KEY-----`

const jwt = {
  sign: (payload, exires = 60 * 60) => {
    return jwtutil.sign(payload, privateKey, {
      algorithm: 'RS256',
      expiresIn: exires
    }) // 一小时过期
  },
  verify: (token) => {
    try {
      return jwtutil.verify(token, publicKey, { algorithms: ['RS256'] })
    } catch (e) {
      if (process.env.NODE_ENV !== 'production') console.log(e)
      return false
    }
  },
  decode: (token) => {
    try {
      return jwtutil.decode(token)
    } catch (e) {
      if (process.env.NODE_ENV !== 'production') console.log(e)
      return false
    }
  }
}

export default jwt
